import { clearPremiumGracePeriod } from "./premiumGracePeriod";

// Wipes every client-side trace of the current visitor so the app reboots as a
// fresh anonymous device user. Clears the storages wholesale rather than an
// enumerated key list, which would go stale as keys are added.
export const resetAppData = () => {
  localStorage.clear();
  sessionStorage.clear();
  clearPremiumGracePeriod();
  window.location.reload();
};
